import React, { Component } from 'react';
import DropDown2 from './DropDown2'

const meterStyleAPIValues = ["A", "H", "C", "O"]
const meterStyleDisplay =  ["All", "Hot", "Cold", "Other"]

export default class StyleDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: meterStyleDisplay,
    }
  }
  render () {
    const dd2 = StyleDisplay (this.props?.value)
    return <DropDown2 {...this.state} {...this.props} value={dd2}
        onUpdate={(param)=>this.props.onUpdate (meterStyleAPIValues[param], this.props)}/>
  }
}
export function StyleDisplay (apiValue) {
  const found = meterStyleAPIValues.indexOf(apiValue ?? '')
  return found < 0 ? (apiValue ? apiValue : "Not Available") : meterStyleDisplay[found]
}